import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import { useFloatingPosition } from '@shared/hooks';
import { Flex, UiText } from '@shared/ui';

import cls from './ChartBar.module.css';

interface IChartBarProps {
    widthPercent: string;
    color?: string;
    label?: string;
    value: string;
    valueDetails?: string;
    className?: string;
    barClassName?: string;
    labelClassName?: string;
    valueWrapperWidth?: number;
    renderTooltip?: () => React.ReactNode;
}

export const ChartBar = React.forwardRef<HTMLDivElement, IChartBarProps>(
    (
        {
            widthPercent = '0',
            color = '#1094F7',
            valueDetails,
            value,
            label,
            className,
            barClassName,
            labelClassName,
            renderTooltip,
        },
        ref
    ) => {
        const anchorRef = React.useRef<HTMLDivElement>(null);
        const { refs, floatingStyles, getFloatingProps } = useFloatingPosition({
            anchorRef,
            placement: 'top',
        });

        const [animatedWidth, setAnimatedWidth] = useState('0');

        useEffect(() => {
            setAnimatedWidth(widthPercent);
        }, [widthPercent]);

        return (
            <Flex gap={8} className={cn(cls.ChartBarContainer, className)}>
                <div className={cn(cls.barContainer, barClassName)}>
                    <span
                        className={cls.bar}
                        style={{ backgroundColor: color, width: animatedWidth }}
                        ref={anchorRef}
                    >
                        <UiText
                            align="left"
                            variant="mediumPlain"
                            className={cn(cls.label, labelClassName)}
                        >
                            {label}
                        </UiText>
                        <div
                            className={cn(cls.tooltipContainer)}
                            ref={refs.setFloating}
                            style={floatingStyles}
                            {...getFloatingProps()}
                        >
                            {renderTooltip && renderTooltip()}
                        </div>
                        <Flex className={cls.valueWrapper} ref={ref}>
                            <UiText variant="mediumPlain">
                                {value} {valueDetails}
                            </UiText>
                        </Flex>
                    </span>
                </div>
            </Flex>
        );
    }
);
